module.exports = __webpack_public_path__ + "img/classic.2b123098.png";